export default class LatLonFilialeRequest {
  filialeId: string
  latitude: number
  longitude: number
}
